import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import WizardSubtitleText from 'Views/Page/Content/Modal/Layouts/DefaultStep/Layout/WizardSubtitleText';
import DetailItems from './Layout/DetailItems';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride(['moduleName'], {
    hidden: true,
  })
  .nameOverride('detailItems', {
    _component: () => DetailItems,
    _spreadPropNames: ['resource', 'attrName'],
  }, { ordinal: 200 })
  .nameOverride('subtitle', {
    _component: () => WizardSubtitleText,
  }, { ordinal: 200 });

export const facetPlanDetailsMetaOverrideSet = fr.metaOverride({ base: BaseOverride })
  .nameOverride(['moduleName', 'title', 'primaryActionLabel'], {
    hidden: true,
  }, { ordinal: 200 })
  .nameOverride('detailItems', {
    _component: () => DetailItems,
    _spreadPropNames: ['resource', 'attrName'],
  }, { ordinal: 200 })
  .nameOverride('subtitle', {
    _component: () => WizardSubtitleText,
  }, { ordinal: 200 });
